import React, { Component } from 'react'
import Link from 'gatsby-link'
import WordmarkImage from '../images/wordmark.png'
import Modal from 'react-modal'

Modal.setAppElement('#___gatsby')

class Banner extends Component {
  state = {
    modalIsOpen: false,
  }

  onOpenModal = () => {
    this.setState({ modalIsOpen: true })
  }

  onCloseModal = () => {
    this.setState({ modalIsOpen: false })
  }

  render() {
    return (
      <section className="banner">
        <Modal
          className="modal"
          overlayClassName="modal-overlay"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.onCloseModal}
        >
          <button className="close" onClick={this.onCloseModal}>
            <span>&times;</span>
          </button>
          <div className="iframeContainer">
            <iframe
              src="https://www.youtube.com/embed/7fuPyfFC-hw?autoplay=1&rel=0"
              id="video"
              allow="autoplay; encrypted-media"
              allowscriptaccess="always"
              allowFullScreen
            />
          </div>
        </Modal>
        <div className="container">
          <header>
            <img height src={WordmarkImage} />
          </header>
          <span
            className="logo btn btn-primary video-btn"
            onClick={this.onOpenModal}
          >
            Play trailer
          </span>
        </div>
      </section>
    )
  }
}
export default Banner



// WEBPACK FOOTER //
// ./src/components/banner.js